import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import useScrollReveal from "./hooks/useScrollReveal";
import Header from "./components/site/Header";
import Hero from "./components/site/Hero";
import About from "./components/site/About";
import WhyChoose from "./components/site/WhyChoose";
import Course from "./components/site/Course";
import Admission from "./components/site/Admission";
import Gallery from "./components/site/Gallery";
import Testimonials from "./components/site/Testimonials";
import Contact from "./components/site/Contact";
import Footer from "./components/site/Footer";

const Home = () => {
    useScrollReveal();
    return (
        <main data-testid="home-page" className="bg-[var(--bg-page)]">
            <Header />
            <Hero />
            <About />
            <WhyChoose />
            <Course />
            <Admission />
            <Gallery />
            <Testimonials />
            <Contact />
            <Footer />
        </main>
    );
};

function App() {
    return (
        <div className="App">
            <Toaster position="top-center" richColors closeButton />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
